export default __webpack_public_path__ + "static/media/recordPlayer.d4754cd8.mp4";